import { useSelector } from "react-redux";
import ButtonLoader from "../../../UI/Loaders/Loaders";
import { Fragment, useLayoutEffect, useState } from "react";
import { showModal } from "../../../redux/actions/modal";
import { useDispatch } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
// Required for pdfjs worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const CustomerOfferLetterSlaViewer = ({
  dataRecord: {
    documentUrl,
    type,
    customer_id,
    id,
    loan_application_id,
    offer_letter_detail_id,
  },
  onCloseModal,
}: {
  dataRecord: any;
  onCloseModal: () => void;
}) => {
  const [documentData, setDocumentData] = useState({
    documentUrl: documentUrl,
    type: type,
    isLoading: true,
  });
  const [numPages, setNumPages] = useState<number | null>(null);

  const dispatch = useDispatch();

  const updatedDocumentData = useSelector(
    // @ts-ignore
    (state) => state?.documentViewerReducer,
  );

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  useLayoutEffect(() => {
    if (updatedDocumentData?.documentUrl) {
      setDocumentData({
        documentUrl: updatedDocumentData?.documentUrl,
        type: updatedDocumentData?.type,
        isLoading: updatedDocumentData?.isLoading,
      });
    }
  }, [updatedDocumentData]);

  const handleApproveRejectOfferSla = (action: "approve" | "reject") => {
    dispatch(
      showModal({
        modalIdentifier: "approverejectoffersla",
        dataRecord: {
          action,
          id,
          loan_application_id,
          customer_id,
          offer_letter_detail_id,
        },
      }),
    );
  };
  const handleApproval = async (action: "approve" | "reject") => {
    handleApproveRejectOfferSla(action);
  };

  const handleReject = async (action: "approve" | "reject") => {
    handleApproveRejectOfferSla(action);
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <h3 className="Modal__title p-b-1"></h3>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {documentData?.isLoading ? (
              <ButtonLoader />
            ) : (
              <>
                {/* Image preview */}
                {documentData?.type?.startsWith("image/") && (
                  <img
                    src={documentData?.documentUrl}
                    alt="Preview"
                    style={{
                      maxWidth: "1000px",
                      maxHeight: "800px",
                      objectFit: "contain",
                    }}
                  />
                )}

                {/* PDF preview */}
                {documentData?.type === "application/pdf" && (
                  // <embed
                  //   src={documentData?.documentUrl}
                  //   type="application/pdf"
                  //   width="1000"
                  //   height="800"
                  //   style={{ border: "none" }}
                  //   title="PDF Viewer"
                  // />

                  <div
                    style={{
                      width: "1000px",
                      height: "800px",
                      overflow: "auto",
                    }}
                  >
                    <Document
                      file={documentData?.documentUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<ButtonLoader />}
                    >
                      {Array.from(new Array(numPages), (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                          width={900}
                        />
                      ))}
                    </Document>
                  </div>
                )}

                {/* Word/Excel/PowerPoint */}
                {(documentData?.type?.includes("word") ||
                  documentData?.type?.includes("excel") ||
                  documentData?.type?.includes("presentation")) && (
                  <iframe
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                      documentData?.documentUrl,
                    )}`}
                    width="1000"
                    height="800"
                    style={{ border: "none" }}
                    title="Office Document Viewer"
                  />
                )}

                {/* Fallback for unknown types */}
                {!documentData?.type?.startsWith("image/") &&
                  documentData?.type !== "application/pdf" &&
                  !(
                    documentData?.type?.includes("word") ||
                    documentData?.type?.includes("excel") ||
                    documentData?.type?.includes("presentation")
                  ) && (
                    <object
                      type={documentData?.type}
                      data={documentData?.documentUrl}
                      width="1000"
                      height="800"
                      style={{ objectFit: "contain" }}
                    >
                      <p>
                        Cannot preview this file.{" "}
                        <a
                          href={documentData?.documentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download instead
                        </a>
                      </p>
                    </object>
                  )}
              </>
            )}
          </div>

          <div className="Form__action-buttons m-t-2">
            {
              <Fragment>
                <button
                  type="button"
                  className="btn zoom-element login-btn"
                  onClick={() => handleApproval("approve")}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="btn zoom-element reject_btn"
                  onClick={() => handleReject("reject")}
                >
                  Reject
                </button>
              </Fragment>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerOfferLetterSlaViewer;
